import { render, staticRenderFns } from "./TipScrollAuto.vue?vue&type=template&id=72c2c50e&scoped=true&"
import script from "./TipScrollAuto.vue?vue&type=script&lang=js&"
export * from "./TipScrollAuto.vue?vue&type=script&lang=js&"
import style0 from "./TipScrollAuto.vue?vue&type=style&index=0&id=72c2c50e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c2c50e",
  null
  
)

export default component.exports